import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Breadcrumb, Table } from "@themesberg/react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FacilityBaseUrl } from "../Routes/BaseUrl";

export default () => {
  const { id } = useParams();
  const [facilityDetails, setFacilityDetails] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchFacilityDetails = async () => {
      try {
        const response = await axios.get(
          `${FacilityBaseUrl.trim()}/facility/getfacilityProfile/single/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const facility = response.data.data;
        setFacilityDetails(facility);
      } catch (error) {
        console.error("Error fetching facility details:", error);
      }
    };
    fetchFacilityDetails();
  }, [id]);

  if (!facilityDetails) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Avijo</Breadcrumb.Item>
            <Breadcrumb.Item href="/FacilityList">Facility List</Breadcrumb.Item>
            <Breadcrumb.Item active>{facilityDetails.fullName}</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Facility Details</h4>
        </div>
      </div>
      <Table striped bordered hover className="mb-4">
        <tbody>
          <tr>
            <td>Full Name</td>
            <td>{facilityDetails.fullName}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{facilityDetails.emailId}</td>
          </tr>
          <tr>
            <td>Mobile Number</td>
            <td>{facilityDetails.mobileNumber}</td>
          </tr>
          <tr>
            <td>Business Name</td>
            <td>{facilityDetails.businessName}</td>
          </tr>
          <tr>
            <td>Business Title</td>
            <td>{facilityDetails.businessTitle}</td>
          </tr>
          <tr>
            <td>Drug Licence Number</td>
            <td>{facilityDetails.drugLicenceNo}</td>
          </tr>
          <tr>
            <td>FSSAI Licence Number</td>
            <td>{facilityDetails.fssaiLicenceNo}</td>
          </tr>
          <tr>
            <td>GST Number</td>
            <td>{facilityDetails.gstNo}</td>
          </tr>
          <tr>
            <td>PAN Number</td>
            <td>{facilityDetails.panNo}</td>
          </tr>
          <tr>
            <td>Register</td>
            <td>{facilityDetails.register}</td>
          </tr>
          <tr>
            <td>Address Line 1</td>
            <td>{facilityDetails.addressLineNo1}</td>
          </tr>
          <tr>
            <td>Address Line 2</td>
            <td>{facilityDetails.addressLineNo2}</td>
          </tr>
          <tr>
            <td>City/District</td>
            <td>{facilityDetails.cityDistrict}</td>
          </tr>
          <tr>
            <td>Pincode</td>
            <td>{facilityDetails.pincode}</td>
          </tr>
          <tr>
            <td>State</td>
            <td>{facilityDetails.state}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};
